const TRUTHY_ENV_VALUES = ['1', 'true', 'yes', 'on']
const FALSY_ENV_VALUES = ['0', 'false', 'no', 'off']

const parseBooleanEnv = (value, fallback = false) => {
  if (typeof value === 'undefined' || value === null || value === '') return fallback

  const normalizedValue = String(value).trim().toLowerCase()

  if (TRUTHY_ENV_VALUES.includes(normalizedValue)) return true
  if (FALSY_ENV_VALUES.includes(normalizedValue)) return false

  return fallback
}

export const features = Object.freeze({
  kpi: parseBooleanEnv(process.env.VUE_APP_FEATURE_KPI, false)
})

export default features
